import { isPlatformServer } from "@angular/common";
import { inject, PLATFORM_ID } from "@angular/core";
import { Router, type CanActivateFn } from "@angular/router";
import { CbRoutesUtils } from "@app/@classes/routes/cb-routes-utils";
import { AuthTenantService } from "@app/@services/shared/auth-tenant.service";
import { AuthService } from "@app/@services/shared/auth.service";
import { PalmtopService } from "@app/@services/shared/palmtop.service";
import { ErrorHandlerService } from "@app/@services/shared/error-handler.service";
import { LoggerService } from "@app/@services/shared/logger.service";

export const palmtopWarehouseGuard: CanActivateFn = (route, state) => {
	const selectWarehouseUrl = CbRoutesUtils.paths.w.palmtop_choose_warehouse.path;
	const router = inject(Router);
	const loggerService = inject(LoggerService);
	const platformId = inject(PLATFORM_ID);
	const palmtopService = inject(PalmtopService);

	loggerService.logInfo(
		"[WarehousePalmtopGuard] Checking if warehouse is selected",
	);

	const warehouseId = palmtopService.getWarehouseId();

	console.log("warehouseId", warehouseId);

	if (isPlatformServer(platformId)) {
		return true;
	}

	if (warehouseId == null || warehouseId === undefined || warehouseId === "") {
		loggerService.logWarning(
			"No warehouse selected, navigating to warehouse selection page",
		);
		router.navigate([selectWarehouseUrl]);
		return false;
	}

	return true;
};
